import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a427f',
        secondary: '#009a4e',
        background: '#f1f8e9'
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es',
  },
})
